
let eventGuid = 0
let todayStr = new Date().toISOString().replace(/T.*$/, '') // YYYY-MM-DD of today

export const INITIAL_EVENTS = [
    {
        id: createEventId(),
        title: 'Online',
        start: '2025-02-20',
        color: '#487fff'
    },
    {
        id: createEventId(),
        title: 'Dehradun Shivpuri',
        start: '2025-02-13',
        color: '#f4941e'
    },
    {
        id: createEventId(),
        title: 'Online',
        start: '2025-02-07',
        color: '#487fff'
    },
    {
        id: createEventId(),
        title: 'Dehradun Mohitnagar',
        start: '2025-02-15',
        color: '#f4941e'
    },
    {
        id: createEventId(),
        title: 'Online',
        start: '2025-02-05',
        color: '#487fff'
    },
    {
        id: createEventId(),
        title: 'Karnataka Hebbal',
        start: '2025-02-10',
        color: '#f4941e'
    },
    {
        id: createEventId(),
        title: 'Online',
        start: '2025-02-17',
        color: '#487fff'
    },
    {
        id: createEventId(),
        title: 'Timed event',
        start: todayStr,
        color: '#487fff'
    }
]

export function createEventId() {
    return String(eventGuid++)
}
